// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2_Dsc","bigColWidth":"Table_bigColWidth__2Akkf","biggerColWidth":"Table_biggerColWidth__O0Luo","row":"Table_row__38prV","col":"Table_col__4rWxq"};